import React from 'react';

export const StartingScreensaverUI = () => {
    return (
        <div style={{height: '100vh', width: '100vw', display: 'flex', alignItems: 'center', backgroundColor: '#ccccff'}}>
            <div style={{width: '80vw', margin: '20px auto'}}>
                <h1 style={{margin: '0 0 25px', textAlign: 'center', color: '#4b44b4'}}>&#8497;i&#769;r&#949;ss &#8499;&#949;ss&#949;ng&#949;r</h1>
                <h2 style={{margin: '0 0 25px', textAlign: 'center', color: '#111111'}}>Подключение к сайту</h2>
                <h3 style={{textAlign: 'center', color: '#444444', margin: '0'}}>Это может занять некоторое время</h3>
            </div>
        </div>
    )
};
